import { createSlice } from '@reduxjs/toolkit';

const provider = createSlice({
    name        : 'provider',
    initialState: {
        accessToken     : null,
        customer        : null,
        invoiceData     : null,
        queryData       : null,
    },
    reducers: create => ({
        setAccessToken: create.reducer( (state, action) => {
            state.accessToken = action.payload
        }),
        setCustomer: create.reducer( (state, action) => {
            state.customer = action.payload
        }),
        setInvoiceData: create.reducer( (state, action) => {
            state.invoiceData = action.payload
        }),
        setQueryData: create.reducer( (state, action) => {
            state.queryData = {
                customerIdentity: action.payload
            }
        }),
         
    })
})

export default provider